import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const ProjectStatusOne = () => {
  const [ongoingBatches, setOngoingBatches] = useState([]);
  const [roleName, setRoleName] = useState("");
  const [userName, setUserName] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    const user = localStorage.getItem("user");
    if (!user || !storedToken) {
      navigate("/");
      return;
    }
    const parsedUser = JSON.parse(user);
    setRoleName(parsedUser?.rolename);
    setUserName(parsedUser?.userName);
  }, [navigate]);

  useEffect(() => {
    const fetchOngoingBatchData = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          // console.log("Access required");
          return;
        }
        let url;
        const urlAll = `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-ongoing-batch`;
        const urlTutor = `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-ongoing-batch-tutor`;
        if (roleName) {
          if (roleName === "Tutor" && userName !== "E2TMT0001") {
            url = urlTutor;
          } else {
            url = urlAll;
          }
        }
        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setOngoingBatches(response?.data?.data);
        // console.log(response);

        // console.log(response);
      } catch (error) {
        // console.log(error);
      }
    };

    fetchOngoingBatchData();
  }, [roleName, userName]);
  return (
    <div className="col-xxl-5">
      <div className="card h-100">
        <div className="card-body p-24">
          <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between mb-20">
            <h6 className="mb-2 fw-bold text-lg">Ongoing Batch</h6>
            {/* <div className="">
                            <select className="form-select form-select-sm w-auto bg-base border text-secondary-light" defaultValue="Yearly">
                                <option value="Yearly">Yearly</option>
                                <option value="Monthly">Monthly</option>
                                <option value="Weekly">Weekly</option>
                                <option value="Today">Today</option>
                            </select>
                        </div> */}
          </div>
          <div className="table-responsive scroll-sm">
            <table className="table sm-table bordered-table mb-0">
              <thead>
                <tr>
                  <th scope="col">S.N</th>
                  <th scope="col">Batch</th>
                  <th scope="col">
                    <div className="max-w-112 mx-auto">
                      <span>Course</span>
                    </div>
                  </th>
                  <th scope="col">NO. Students</th>
                </tr>
              </thead>
              <tbody>
                {ongoingBatches.length > 0 ? (
                  ongoingBatches.map((item, index) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{item?.batch_name}</td>
                      <td>{item?.courseData?.coursename}</td>
                      <td>{item?.studentCount}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colspan="4" className="text-center">
                      No Ongoing Batches
                    </td>
                  </tr>
                )}
                {/* <tr>
                                    <td>Gold</td>
                                    <td>2 Months</td>
                                    <td>
                                        <div className="max-w-112 mx-auto">
                                            <div className="w-100">
                                                <div
                                                    className="progress progress-sm rounded-pill"
                                                    role="progressbar"
                                                    aria-label="Success example"
                                                    aria-valuenow={25}
                                                    aria-valuemin={0}
                                                    aria-valuemax={100}
                                                >
                                                    <div
                                                        className="progress-bar bg-red rounded-pill"
                                                        style={{ width: "30%" }}
                                                    />
                                                </div>
                                            </div>
                                            <span className="mt-8 text-secondary-light text-sm fw-medium">
                                                30%
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Dollars</td>
                                    <td>3 Months</td>
                                    <td>
                                        <div className="max-w-112 mx-auto">
                                            <div className="w-100">
                                                <div
                                                    className="progress progress-sm rounded-pill"
                                                    role="progressbar"
                                                    aria-label="Success example"
                                                    aria-valuenow={25}
                                                    aria-valuemin={0}
                                                    aria-valuemax={100}
                                                >
                                                    <div
                                                        className="progress-bar bg-warning-main rounded-pill"
                                                        style={{ width: "50%" }}
                                                    />
                                                </div>
                                            </div>
                                            <span className="mt-8 text-secondary-light text-sm fw-medium">
                                                50%
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Stock Market</td>
                                    <td>1 Months</td>
                                    <td>
                                        <div className="max-w-112 mx-auto">
                                            <div className="w-100">
                                                <div
                                                    className="progress progress-sm rounded-pill"
                                                    role="progressbar"
                                                    aria-label="Success example"
                                                    aria-valuenow={25}
                                                    aria-valuemin={0}
                                                    aria-valuemax={100}
                                                >
                                                    <div
                                                        className="progress-bar bg-info-main rounded-pill"
                                                        style={{ width: "60%" }}
                                                    />
                                                </div>
                                            </div>
                                            <span className="mt-8 text-secondary-light text-sm fw-medium">
                                                60%
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Dimond</td>
                                    <td>5 Months</td>
                                    <td>
                                        <div className="max-w-112 mx-auto">
                                            <div className="w-100">
                                                <div
                                                    className="progress progress-sm rounded-pill"
                                                    role="progressbar"
                                                    aria-label="Success example"
                                                    aria-valuenow={25}
                                                    aria-valuemin={0}
                                                    aria-valuemax={100}
                                                >
                                                    <div
                                                        className="progress-bar bg-success-main rounded-pill"
                                                        style={{ width: "80%" }}
                                                    />
                                                </div>
                                            </div>
                                            <span className="mt-8 text-secondary-light text-sm fw-medium">
                                                80%
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>S&amp;P 500</td>
                                    <td>4 Months</td>
                                    <td>
                                        <div className="max-w-112 mx-auto">
                                            <div className="w-100">
                                                <div
                                                    className="progress progress-sm rounded-pill"
                                                    role="progressbar"
                                                    aria-label="Success example"
                                                    aria-valuenow={25}
                                                    aria-valuemin={0}
                                                    aria-valuemax={100}
                                                >
                                                    <div
                                                        className="progress-bar bg-red rounded-pill"
                                                        style={{ width: "70%" }}
                                                    />
                                                </div>
                                            </div>
                                            <span className="mt-8 text-secondary-light text-sm fw-medium">
                                                70%
                                            </span>
                                        </div>
                                    </td>
                                </tr> */}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectStatusOne;
